import Logo from "./Logo";
import NavigationButtons from "./NavigationButtons";

export default function Header() {
  return (
    <nav className="border-b border-gray-200 backdrop-blur-sm bg-white/90 sticky top-0 z-50 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Logo />
          </div>

          {/* CTA Buttons */}
          <NavigationButtons />
        </div>
      </div>
    </nav>
  );
}
